import { useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useDashboardData } from "@/hooks/useDashboardData";
import OrderStatusSummary from '@/components/OrderStatusSummary';
import CustomerMonthlyTotalsCard from '@/components/CustomerMonthlyTotalsCard';
import BlacklistSummaryCard from '@/components/BlacklistSummaryCard';
import UnifiedOrderSearchCard from '@/components/UnifiedOrderSearchCard';
import { useAuth } from '@/hooks/useAuth';
import { useLoginModal } from '@/contexts/LoginModalContext';

export default function Dashboard() {
  const { user, loading: authLoading } = useAuth();
  const { openLoginModal } = useLoginModal();
  const { summary, isSummaryLoading, summaryError, summaryDays, summaryLoadedDays, setSummaryDays, fetchSummaryData } = useDashboardData();

  useEffect(() => {
    if (user) {
      fetchSummaryData();
    }
  }, [fetchSummaryData, user]);

  if (authLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <Loader2 className="h-16 w-16 animate-spin text-gray-400" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="h-full flex justify-center pt-32">
        <Card className="w-full max-w-md mx-auto text-center">
          <CardHeader>
            <CardTitle>로그인이 필요합니다</CardTitle>
            <CardDescription>
              대시보드 기능을 이용하려면 로그인해주세요.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button onClick={() => openLoginModal()}>로그인 / 회원가입</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto p-5 space-y-6">
        <UnifiedOrderSearchCard />

        <OrderStatusSummary summary={summary} isLoading={isSummaryLoading} error={summaryError} days={summaryDays} loadedDays={summaryLoadedDays} onDaysChange={setSummaryDays} onRetry={fetchSummaryData} />

        <CustomerMonthlyTotalsCard />

        <BlacklistSummaryCard />
      </div>
    </div>
  );
}
